import { render, staticRenderFns } from "./WhyChoose.vue?vue&type=template&id=0618f11f&scoped=true"
import script from "./WhyChoose.vue?vue&type=script&lang=js"
export * from "./WhyChoose.vue?vue&type=script&lang=js"
import style0 from "./WhyChoose.vue?vue&type=style&index=0&id=0618f11f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0618f11f",
  null
  
)

export default component.exports